<ion-menu menuId="user-menu" contentId="root-content" side="end" *ngIf="langReady">
  <ion-header>
    <div class="user-menu-header">
      <bh-user-icon
        [userFullName]="authUser?.name ?? null"
        [userId]="authUser?.userId ?? null"
      ></bh-user-icon>
      <div class="user-name" *ngIf="authUser?.userId">
        <strong>{{ authUser?.name ?? null }}</strong>
        <span class="user-role">{{ authUser?.role | formatRole | translate }}</span>
      </div>
      <div class="sign-in" *ngIf="!authUser?.userId">
        <ion-button
          fill="outline"
          size="small"
          expand="block"
          (click)="signIn()"
          analyticsClick
          eventName="user-menu: sign-in"
          >{{ 'Sign in' | translate }}</ion-button
        >
      </div>
      <div class="close-button">
        <ion-button fill="clear" (click)="closeMenu()">
          <ion-icon name="close-outline" slot="icon-only"></ion-icon>
        </ion-button>
      </div>
    </div>
  </ion-header>
  <ion-content>
    <ion-list>

      <!-- Account -->
      <ng-container *ngIf="authUser?.userId">
        <div class="padding-bottom-24"></div>
        <ion-item-divider>{{ 'Account' | translate }}</ion-item-divider>
        <ion-item
          button
          (click)="openMyAccount()"
          analyticsClick
          eventName="user-menu: my-account"
        >
          <ion-icon name="person-circle-outline" slot="start" aria-hidden="true"></ion-icon>
          <ion-label>{{ 'My account' | translate }}</ion-label>
        </ion-item>
        <ion-item
          button
          (click)="navService.navigateRoot('/tabs/admin-landing')"
          analyticsClick
          eventName="user-menu: admin-landing"
          *ngIf="authService.isAdminOrSysAdmin(authUser)"
        >
          <ion-icon name="shield-checkmark-outline" slot="start" aria-hidden="true"></ion-icon>
          <ion-label>{{ 'Admin landing' | translate }}</ion-label>
        </ion-item>
        <ion-item
          button
          (click)="signOut()"
          analyticsClick
          eventName="user-menu: sign-out"
        >
          <ion-icon name="log-out-outline" slot="start" aria-hidden="true"> </ion-icon>
          <ion-label>{{ 'Sign out' | translate }}</ion-label>
        </ion-item>
      </ng-container>

      <!-- Other Topics -->
      <div class="padding-bottom-24"></div>
      <ion-item-divider>{{ 'Other topics' | translate }}</ion-item-divider>
      <ion-item
        button
        (click)="openFeedback()"
        analyticsClick
        eventName="user-menu: feedback"
      >
        <ion-icon name="volume-medium-outline" slot="start" aria-hidden="true"></ion-icon>
        <ion-label>{{ 'Give feedback' | translate }}</ion-label>
      </ion-item>
      <ion-item
        button
        (click)="openHelp()"
        analyticsClick
        eventName="user-menu: information"
      >
        <ion-icon name="information-circle-outline" slot="start" aria-hidden="true"></ion-icon>
        <ion-label>{{ 'Information' | translate }}</ion-label>
      </ion-item>
    </ion-list>
  </ion-content>
</ion-menu>
<ion-app *ngIf="langReady">
  <ion-router-outlet id="root-content"></ion-router-outlet>
</ion-app>
<div class="loader-backdrop" [ngClass]="{ show: isLoading }">
  <div class="spinner-wrapper">
    <div class="spinner-background">
      <ion-spinner class="loading-modal-spinner"></ion-spinner>
      <div class="loading-message" *ngIf="loadingMessage">
        {{ loadingMessage | translate }}
      </div>
    </div>
  </div>
</div>
